import { gql } from '@apollo/client';

export const FLUX_GENERATIONS = gql`
  query FluxGeneration {
    fluxGenerations {
      id
      status
      planId
      sourceImage
      data
      sqsMessageId
      createdAt
      updatedAt
      executionTime
    }
  }
`;

export const FLUX_GENERATIONS_BY_PLAN_ID = gql`
  query FluxGeneration($planId: ID!) {
    fluxGenerationByPlanId(planId: $planId) {
      id
      status
      planId
      sourceImage
      data
      sqsMessageId
      createdAt
      updatedAt
      executionTime
    }
  }
`;
